import { Link } from "react-router-dom";
import { heroData } from "@/mocks/home";

export default function HeroBanner() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Fashion%20style%20collage%20with%20Japanese%20minimalist%20Korean%20modern%20European%20classic%20aesthetic%2C%20warm%20cream%20and%20beige%20tones%2C%20soft%20natural%20lighting%2C%20editorial%20fashion%20photography%2C%20elegant%20textile%20textures%2C%20artistic%20composition%20with%20fabric%20draping&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="日韩欧美潮流时尚风格精选"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <span className="inline-block px-4 py-1.5 mb-4 md:mb-6 text-xs md:text-sm font-medium text-background-50 bg-primary-500/80 backdrop-blur-sm rounded-full tracking-wider">
          {heroData.subtitle}
        </span>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-4 md:mb-6 leading-tight max-w-3xl">
          {heroData.title}
        </h1>
        <p className="text-sm md:text-base text-background-50/85 max-w-2xl mb-6 md:mb-8 leading-relaxed">
          {heroData.description}
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to={heroData.ctaLink}
            className="px-8 py-3 bg-primary-500 text-background-50 text-sm md:text-base font-medium rounded-full hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            {heroData.ctaText}
          </Link>
          <Link
            to={heroData.secondaryLink}
            className="px-8 py-3 bg-background-50/20 backdrop-blur-sm text-background-50 text-sm md:text-base font-medium rounded-full hover:bg-background-50/30 transition-all duration-200 cursor-pointer border border-background-50/30 whitespace-nowrap"
          >
            {heroData.secondaryText}
          </Link>
        </div>
      </div>
    </section>
  );
}